import React from "react";
import { Button, Grid, Modal, Typography } from "@mui/material";
// import withStyles from "@material-ui/core/styles/withStyles";
import "./styles.css";
import "animate.css/animate.css";

const EvaluatorModal = ({
  classes,
  setModalOpend
}) => {
  return (
    <Modal open={true}>
      <Grid
        container
        justify="center"
        alignItems="center"
        style={{ height: "100vh", justifyContent: "center" }}
      >
        <Grid className="evaluatorModalContainer">
          <Typography className="evalDesc" style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: "Fiscal Policy is <i>very</i> hard to get right!" }} />
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "In order for it to restart the economy it needs to put underemployed workers/assets back to work. So it functions best when responding to a demand shock and when it’s properly targeted and timely." }}>
          </Typography>
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "Here’s how the slot machine works: the first reel is the downturn cause, the second reel is the policy and the third reel is the details of the implementation." }}>
          </Typography>
          <Typography className="evalDesc" dangerouslySetInnerHTML={{ __html: "You have to nail all three for Fiscal Policy to revive the economy." }}>
          </Typography>
          <Typography className="evalDesc" style={{ fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: "So, ready? See if you “Keynes” can hit the fiscal policy jackpot!" }}>
          </Typography>
          <Grid container style={{ justifyContent: "center" }}>
            <Button className="submitButton" onClick={() => setModalOpend(false)}>
              NEXT
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};

export default EvaluatorModal;
